<div *ngIf="panelErrorStatusService.errorsPresent(this.panel)">
  <!-- _reload here is a technique to force the component to reload with the new data -->
  <span *ngIf="_reload">
    <app-panel-errors-info-button [panelId]="panel._id"></app-panel-errors-info-button>
  </span>
</div>
